import { RouteHelpers } from '@/mixins';
import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const DocuSignAfterSignMappingsManagement = () =>
  import(
    /* webpackChunkName: "DocusignAfterSignMappingsManagement" */
    '@/views/configuration/docusign/DocusignAfterSignMappingsManagement.vue'
  );

const DocuSignEditTemplateAfterSignMappings = () =>
  import(
    /* webpackChunkName: "EditTemplateAfterSignMappings" */
    '@/views/configuration/docusign/DocuSignEditTemplateAfterSignMappings.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'docusignaftersignmappings',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'DocuSign After Sign Mappings'
};

export const AfterSignMappingRoutes = [
  {
    ...Configuration.DocuSign.AfterSignMapping.Management,
    components: {
      default: DocuSignAfterSignMappingsManagement,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.DocuSign.AfterSignMapping.Edit,
    components: {
      default: DocuSignEditTemplateAfterSignMappings,
      treeView: ConfigurationTreeView
    },
    meta: {
      ...meta,
      model: 'docusignaftersign'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.DocuSign.AfterSignMapping.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['id']);
    }
  }
];
